import { render } from "./ListGroupItem.vue?vue&type=template&id=f1de8f6a"
import script from "./ListGroupItem.vue?vue&type=script&lang=js"
export * from "./ListGroupItem.vue?vue&type=script&lang=js"
script.render = render

export default script